import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApiText } from '@classes/api-text';

@Component({
  selector: 'app-save-invest',
  templateUrl: './save-invest.component.html',
  styleUrls: ['./save-invest.component.scss']
})
export class SaveInvestComponent implements OnInit {
    @Input() text: ApiText;
    @Input() hasProject = true;
    @Output() saveFinished = new EventEmitter<ApiText>();

    isFormVisible = false;
    saveForm: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: { text: ApiText, hasProject: boolean },
        public dialogRef: MatDialogRef<SaveInvestComponent>,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        if(this.data.text) {
            this.text = this.data.text;
            this.hasProject = this.data.hasProject;
        }
        this.initForm();
    }

    onSubmit(): void {
        this.saveFinished.emit(this.saveForm.value);
        this.dialogRef.close(this.saveForm.value);
    }

    onCancel(): void {
        this.saveFinished.emit(null);
        this.dialogRef.close(null);
    }

    private initForm(): void {
        let defaultText = new ApiText('');

        if(this.text) {
            defaultText = this.text;
        }

        this.saveForm = this.fb.group({
            shortLabel: [defaultText.shortLabel, [Validators.required, Validators.minLength(5), Validators.maxLength(25)]],
            summary: [defaultText.summary, [Validators.maxLength(250)]]
        });
    }
}
